module.exports = __webpack_public_path__ + "static/media/ls.ce6b6e82.JPG";